"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const rebass_1 = require("rebass");
const join_1 = tslib_1.__importDefault(require("../utils/join"));
exports.Tag = React.forwardRef((props, ref) => {
    var _a, _b, _c, _d;
    return (React.createElement(rebass_1.Box, Object.assign({}, props, { ref: ref, className: (0, join_1.default)('ab-Tag', props.className), backgroundColor: "primary", paddingTop: (_a = props.paddingTop) !== null && _a !== void 0 ? _a : 1, paddingBottom: (_b = props.paddingBottom) !== null && _b !== void 0 ? _b : 1, paddingLeft: (_c = props.paddingLeft) !== null && _c !== void 0 ? _c : 2, paddingRight: (_d = props.paddingRight) !== null && _d !== void 0 ? _d : 2, style: Object.assign({ borderRadius: 'var(--ab__border-radius)' }, props.style) })));
});
